import JourneyList from '@/components/purchase/journey/JourneyList';
import { setSelectedInboundJourney } from '@/features/purchase/purchaseActions';
import { inboundDataSelector } from '@/features/purchase/purchaseSelectors';
import { TransText } from '@/i18n/trans/text';
import { useSelector } from '@/store/utils';
import { GTM_EVENT } from '@/utils/gtm';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

const InboundJourneyList = () => {
  const navigate = useNavigate();
  const inboundData = useSelector(inboundDataSelector);

  useEffect(() => {
    if (!inboundData.journeys) {
      navigate('/purchase');
    }
  }, [navigate, inboundData.journeys]);

  return (
    <JourneyList
      {...inboundData}
      setSelectedJourney={setSelectedInboundJourney}
      onContinue={() => navigate('/purchase/inbound/offer')}
      journeySelectedEvent={GTM_EVENT.INBOUND_JOURNEY_SELECTED}
      title={<TransText i18nKey="selectReturnTrip" />}
      onGoBack={() => navigate(-1)}
    />
  );
};

export default InboundJourneyList;
